// import { Outlet } from "react-router-dom";

import AppWrapper from "../../../components/cm/AppWrapper";
import SideBarMain from "../../../components/cm/SideBarMain/SideBar";
import ProviderManagement from "../../../components/modules/providers/provider-management/ProviderManagement";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ProviderManagement>{/* <Outlet /> */}</ProviderManagement>
    </AppWrapper.WithSidebar>
  );
};
